// extracted by mini-css-extract-plugin
module.exports = {"section":"more-module--section--pOKYe","title":"more-module--title--1aAGa","button__wrapper":"more-module--button__wrapper--u4glR"};